var userAddressInEdit = false;
var addressChanged = false;

var stickyTime = 5000;

function emailValidation(email)
{
    // var regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(email);
}

function editUserAddress(addressid)
{
    if ( addressid )
    {
        $.ajax({
            url: "/users/profile/addresses/edit/",
            data: "addressid="+addressid,
            method: "POST",
            beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            success: (result)=> {
                $("#address_type").val("normal");
                $("#address_type").trigger("change");
                $("#address_type").prop("disabled", true);

                $("#l_lastname").val(result.last_name);
                $("#l_firstname").val(result.first_name);
                $("#l_phone").val(result.phone);
                $("#l_zip").val(result.zipcode);
                $("#l_city").val(result.city);
                l_city = result.city;
                $("#l_street").val(result.street);
                $("#l_street_type").val(result.street_type);
                $("#l_streetno").val(result.streetno);
                $("#l_street_floor").val(result.street_floor);
                $("#l_descr_store").val(result.comment1);
                $("#l_descr").val(result.comment2);
                $("#addressid").val(result.id);

                $("#l_addressname").val(result.address_name);

                $("#l_country").val(result.country);

                $("#l_zip").trigger("change");
                $("#l_country").trigger("change");

                document.querySelector('#l_phone').dispatchEvent(new Event('blur'))
            }
        });

    }
}

$(document).ready(function() {

    $("#login_form, #login_cart_form").on("submit",function (event) {

        if ( emailValidation($(this).find("input[name=email]").val() ) )
        {
            if ( $(this).find("input[name=password]").val() == "" )
            {
                $(this).parent().add(".input__error").css("z-index","1000");
                $(this).find("input[name=password]").parent().addClass("is-danger");
                event.preventDefault();
            }
        }
        else
        {
            $(this).find("input[name=email]").parent().addClass("is-danger");
            $(this).parent().add(".input__error").css("z-index","1000");
            event.preventDefault();
        }

        $("input[type='hidden'][name='from']").remove();
        $("#login_form").append("<input type='hidden' name='from' value='"+window.location.href+"'>");
        $("#login_cart_form").append("<input type='hidden' name='from' value='"+window.location.href+"'>");

    });

    $("#l_login_email").on("focus",(event)=> {
        if ( $("#l_login_email").parent().hasClass("is-danger") )
        {
            $("#l_login_email").parent().removeClass("is-danger")
        }
    });

    $(".header__link.set_lang").click(function (event) {
        var lang = $(this).data("lang");
        $.ajax({
            url: "/setLang/",
            method: "POST",
            data: "lang="+lang,
            beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            success: ()=>{
                event.stopPropagation();
                location.reload();
            }
        })
    });

    $(".profile__addresses__delete").click(function (event) {
        $.ajax({
            url: "/users/profile/addresses/delete",
            method: "POST",
            data: "deleteId="+$(this).data("address-id"),
            beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            success: ()=>{
                event.stopPropagation();
                location.reload();
            }
        })
    })

    $(".profile__foodaddresses__delete").click(function (event) {
        $.ajax({
            url: "/users/profile/foodaddresses/delete",
            method: "POST",
            data: "deleteId="+$(this).data("address-id"),
            beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            success: ()=>{
                event.stopPropagation();
                location.reload();
            }
        })
    })

    $("#user_profile_form .save-button").click(function(event) {

        var errors = 0;
        $("#user_profile_form input[required=\"required\"]:not(:disabled)").add("#user_profile_form select[required=\"required\"]:not(:disabled)").each(function (element) {
            if ( $(this).prop("id")!="l_billing_country" && $(this).prop("id")!="l_password" && $(this).val()=="" )
            {
                $(this).parent().addClass("is-danger");
                $(this).prev().css("z-index","1000");

                $(this).focus(function(event) {
                    $(this).parent().removeClass("is-danger");
                    $(this).unbind();
                })

                errors++;
            }
            else if ( $(this).prop("id")=="l_password" && $(this).val() != "" && $(this).val().length < 7 )
            {
                $(this).parent().addClass("is-danger");
                $(this).prev().css("z-index","1000");

                $(this).focus(function(event) {
                    $(this).parent().removeClass("is-danger");
                    $(this).unbind();
                })

                errors++;
            }
            else if ( $(this).prop("id")=="l_phone" ) {
                if ($(this).closest('.iti').hasClass('invalid')) {
                    errors++;
                }
            }
            else if ( $(this).prop("id")=="l_billing_country" && $(this).val()=="" )
            {
                $(this).parent().parent().addClass("is-danger");
                $(this).parent().parent().add(".input__error").css("z-index","1000");

                $(this).focus(function(event) {
                    $(this).parent().parent().removeClass("is-danger");
                    $(this).unbind();
                })

                errors++;
            }
        })


        if ( errors == 0 )
        {
            // $("#phone").val($("input [name='phone']").val());
            console.log($("#l_phone").val());
            $("#user_profile_form").submit();
        }
        else
        {
            event.preventDefault();
        }

    });


    $("#user_profile_form #l_country").on("change", function (event) {

        if ( $(this).val() == "hu" )
        {
            $("#l_zip").attr("maxlength",4);
            if ( $("#l_zip").val().length > 4 )
            {
                $("#l_zip").val("");
            }

            //zipcode - city
            $("#user_profile_form .profile_account_shipping_select").css("display","block");
            $("#user_profile_form .profile_account_shipping_select #l_city").prop("disabled",false);
            $("#user_profile_form .profile_account_shipping_text").css("display","none");
            $("#user_profile_form .profile_account_shipping_text #l_city").prop("disabled",true);
        }
        else
        {
            $("#l_zip").attr("maxlength",20);

            //zipcode - city
            $("#user_profile_form .profile_account_shipping_select").css("display","none");
            $("#user_profile_form .profile_account_shipping_select #l_city").prop("disabled",true);
            $("#user_profile_form .profile_account_shipping_text").css("display","block");
            $("#user_profile_form .profile_account_shipping_text #l_city").prop("disabled",false);

        }

        l_country = $(this).val();
    })

    $(".profile__addresses__add #l_country").on("change", function (event) {
        if ( $(this).val() == "hu" )
        {
            $("#l_zip").attr("maxlength",4);
            if ( $("#l_zip").val().length > 4 )
            {
                $("#l_zip").val("");
            }

            //zipcode - city
            $(".profile__addresses__add .profile_account_shipping_select").css("display","block");
            $(".profile__addresses__add .profile_account_shipping_select #l_city").prop("disabled",false);
            $(".profile__addresses__add .profile_account_shipping_text").css("display","none");
            $(".profile__addresses__add .profile_account_shipping_text #l_city").prop("disabled",true);
        }
        else
        {
            $("#l_zip").attr("maxlength",20);

            //zipcode - city
            $(".profile__addresses__add .profile_account_shipping_select").css("display","none");
            $(".profile__addresses__add .profile_account_shipping_select #l_city").prop("disabled",true);
            $(".profile__addresses__add .profile_account_shipping_text").css("display","block");
            $(".profile__addresses__add .profile_account_shipping_text #l_city").prop("disabled",false);
        }

        l_country = $(this).val();
    })

    $("#user_profile_form #l_zip").on("keydown", function (event) {
        var k = event.which || event.keyCode;
        if ( k == 13 )
        {
            event.preventDefault();
            return false;
        }
    });

    $(".profile__addresses__add #l_zip").on("keydown", function (event) {
        var k = event.which || event.keyCode;
        if ( k == 13 )
        {
            event.preventDefault();
            return false;
        }
    });


    $("#user_profile_form #l_zip").on("keyup", function (event) {

        var k = event.which || event.keyCode;
        if ( k == 13 )
        {
            event.preventDefault();
            return false;
        }

        if ( $("#user_profile_form #l_country").val() == "hu" && $(this).val().length == 4 )
        {
            $(this).trigger("change");
        }
    })

    $(".profile__addresses__add #l_zip").on("keyup", function (event) {

        var k = event.which || event.keyCode;
        if ( k == 13 )
        {
            event.preventDefault();
            return false;
        }

        if ( $(".profile__addresses__add #l_country").val() == "hu" && $(this).val().length == 4 )
        {
            $(this).trigger("change");
        }
    })

    // init

    if ( $("#user_profile_form #l_country").val() == "hu" )
    {
        $("#l_zip").attr("maxlength",4);
        if ( $("#l_zip").val().length > 4 )
        {
            $("#l_zip").val("");
        }
    }
    else if ( $("#user_profile_form #l_country").length )
    {
        $("#l_zip").attr("maxlength",20);
    }

    if ( $(".profile__addresses__add #l_country").val() == "hu" )
    {
        $("#l_zip").attr("maxlength",4);
        if ( $("#l_zip").val().length > 4 )
        {
            $("#l_zip").val("");
        }
    }
    else if ( $(".profile__addresses__add #l_country").length )
    {
        $("#l_zip").attr("maxlength",20);
    }




    $("form.profile__addresses__add").on('submit', function(e) {
        e.preventDefault();

        var errors = 0;

        if ($('#l_phone').closest('.iti').hasClass('invalid')) {
            errors++;
        }

        $(".profile__addresses__add input[required=\"required\"]:not(:disabled), .profile__addresses__add select[required=\"required\"]:not(:disabled)").each(function (element) {

            if ( $(this).val() == "" )
            {
                errors++;

                $(this).parent().addClass("is-danger");
                $(this).prev().css("z-index","1000");

                $(this).focus(function(event) {
                    $(this).parent().removeClass("is-danger");
                    $(this).unbind();
                })
            }

        });

        if ( errors == 0 ) {
            // $("#l_phone").val($("#l_phone").data("phone"));
            $("form.profile__addresses__add")[0].submit();
        }
    });

    $("#user_registration_form .save-button").click(function(event) {

        var errors = 0;
        $("#user_registration_form input[required=\"required\"]").each(function (element) {
            if ( $(this).prop("id")=="l_registration_password_again" && $(this).val()!=$("#l_registration_password").val() )
            {
                $(this).parent().addClass("is-danger");
                $(this).prev().css("z-index","1000");

                $(this).focus(function(event) {
                    $(this).parent().removeClass("is-danger");
                    $(this).unbind();
                })
                $("#l_registration_password").focus(function(event) {
                    $("#l_registration_password_again").parent().removeClass("is-danger");
                    $("#l_registration_password_again").unbind();
                })

                errors++;
            }
            else if ( $(this).prop("id")=="l_registration_email" && !emailValidation($(this).val()) )
            {
                $(this).parent().addClass("is-danger");
                $(this).prev().css("z-index","1000");

                $(this).focus(function(event) {
                    $(this).parent().removeClass("is-danger");
                    $(this).unbind();
                })

                errors++;
            }
            else if ( $(this).val()=="" )
            {
                $(this).parent().addClass("is-danger");
                $(this).prev().css("z-index","1000");

                $(this).focus(function(event) {
                    $(this).parent().removeClass("is-danger");
                    $(this).unbind();
                })

                errors++;
            }


            if ( $("#user_registration_form #l_reg_accept_adatkezeles").prop("checked") == false )
            {
                $("#user_registration_form #l_reg_accept_adatkezeles").parent().find(".checkbox__square").css("background","red");
                errors++;
            }

            if ( $("#user_registration_form #l_reg_accept_aszf").prop("checked") == false )
            {
                $("#user_registration_form #l_reg_accept_aszf").parent().find(".checkbox__square").css("background","red");
                errors++;
            }

            $("#user_registration_form #l_reg_accept_adatkezeles").parent().find(".checkbox__square").on("click", function(event) {
                $("#user_registration_form #l_reg_accept_adatkezeles").parent().find(".checkbox__square").css("background","black");
            });

            $("#user_registration_form #l_reg_accept_aszf").parent().find(".checkbox__square").on("click", function(event) {
                $("#user_registration_form #l_reg_accept_aszf").parent().find(".checkbox__square").css("background","black");
            });
        })

        if ( !errors )
        {
            $("#user_registration_form").submit();
        }

    });


    $("#forget_password_form").on("submit", function (event) {
        event.preventDefault();

        if ( $("#l_dropdown_auth_forgot_email").val() != "" && emailValidation($("#l_dropdown_auth_forgot_email").val()) )
        {

            $.ajax({
                url: "/users/forgetpassword",
                method: "POST",
                data: "forgot_email="+$("#l_dropdown_auth_forgot_email").val(),
                beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                success: (result)=>{
                    $(".notification").remove();
					$(".content-wrapper").prepend(JSON.parse(result).notification);
					setTimeout(() => {
						$(".general-sticky").removeClass("is-visible");
                    }, stickyTime);

                    $("#l_dropdown_auth_forgot_email").val("");


                    $('.modal, .modal-layer, .header__link, .navigation, .dropdown').removeClass('is-open')
                    $('.modal, .modal__layer').fadeOut(250)

                    $('.dropdown-toggleform-forgot input').attr('disabled', 'disabled')
                    $('.dropdown-toggleform-forgot').hide()

                    $('.dropdown-toggleform-login').fadeIn(250)
                    $('.dropdown-toggleform-login input').attr('disabled', false)
                }
            })
        }
        else
        {
            $("#l_dropdown_auth_forgot_email").parent().addClass("is-danger");
        }

    });

    $("#region_form").on("submit", function (event) {
        event.preventDefault();

        $.ajax({
            url: "/users/changeregionandcurrency",
            method: "POST",
            data: {
                "region":$("#l_region").val(),
                "currency":$("#l_currency").val()
            },
            beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            success: (result)=>{
                $.ajax({
                    url: "/setLang/",
                    method: "POST",
                    data: "lang="+$("#l_language").val(),
                    beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                    success: ()=>{
                        event.stopPropagation();
                        location.reload();
                    }
                })
            }
        })
    });

    $("#user_password_form").on("submit", function (e) {

        e.preventDefault();


        if ( $("#user_password_form input[name=\"password\"]").val() == "" || $("#user_password_form input[name=\"password_2\"]").val() == "" )
        {
            return;
        }

        $.ajax({
            url: "/users/profile/changepassword",
            method: "POST",
            data: "password="+$("#user_password_form input[name=\"password\"]").val()+"&password_2="+$("#user_password_form input[name=\"password_2\"]").val(),
            beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            success: (result)=> {
                $(".notification").remove();
                $(".content-wrapper").prepend(JSON.parse(result).notification);
                setTimeout(() => {
                    $(".general-sticky").removeClass("is-visible");
                }, stickyTime);

                $("#user_password_form input[name=\"password\"]").val("");
                $("#user_password_form input[name=\"password_2\"]").val("");
            }
        });


    });


    $("#forgotten_password_form").on("submit", function (e) {
        e.preventDefault();

        if ( $("#forgotten_password_form input[name=\"password\"]").val() == "" || $("#forgotten_password_form input[name=\"password_2\"]").val() == ""  )
        {
            return
        }
        else
        {
           $.ajax({
                url: "/users/profile/setnewpassword",
                method: "POST",
                data: "password="+$("#forgotten_password_form input[name=\"password\"]").val()+"&password_2="+$("#forgotten_password_form input[name=\"password_2\"]").val()+"&passwordtoken="+$("#forgotten_password_form input[name=\"passwordtoken\"]").val(),
                beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                success: (result)=> {
                    if ( result == "OK" )
                    {
                        document.location = "/";
                    }
                    else
                    {
                        $(".notification").remove();
                        $(".content-wrapper").prepend(JSON.parse(result).notification);
                        setTimeout(() => {
                            $(".general-sticky").removeClass("is-visible");
                        }, stickyTime);
                    }
                }
            });
        }

    });

    $("#contact-form .select2_select").on('change', function() {
        if ($(this).val() !== '') {
            $(this).parent().removeClass("is-danger");
        }
    });

    $("#contact-form-submit").on("click", function (event) {

        var hasError = false;
        var sendVal = {};

        $("#contact-form input[required='required'], #contact-form select[required='required'], #contact-form textarea[required='required']").each(function (element) {

            if ( $(this).val() == "" || !$(this).val() )
            {
                $(this).parent().addClass("is-danger");

                if ( $(this).attr("id") == "l_phone" )
                {
                    $(this).closest('.iti').addClass('invalid');
                }

                hasError = true;
            }

            if ( $(this).attr("id") == "l_contact_email" && !emailValidation($(this).val()))
            {
                $(this).parent().addClass("is-danger");

                hasError = true;
            }

            if ( $(this).attr("id") == "l_phone" )
            {
                sendVal[$(this).attr("id")] = $(this).data("phone");
            }
            else
            {
                sendVal[$(this).attr("id")] = $(this).val();
            }

        });

        sendVal["l_contact_orderid"] = $("#contact-form #l_contact_orderid").val();

        if ( hasError )
        {
            return false;
        }

        $.ajax({
            url: "/users/sendcontact",
            method: "POST",
            data: {"form": sendVal},
            beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            success: (result)=> {
                if ( result )
                {
                    $("#contact-form")[0].reset();
                    $("#contact-form .select2_select").val("").trigger("change");
                    $("#contact-form #l_phone").closest('.iti').removeClass('valid');

                    $(".notification").remove();
                    $(".content-wrapper").prepend(JSON.parse(result).notification);
                    setTimeout(() => {
                        $(".general-sticky").removeClass("is-visible");
                    }, stickyTime);
                }
            }
        });


    });

    if ( window.location.pathname.indexOf('/users') == 0 && window.location.pathname.indexOf("orders") == -1 && window.location.pathname.indexOf("password") == -1 && window.location.pathname.indexOf("downloadables") == -1 && typeof l_country && l_country == "hu" )
    {
        $("#user_profile_form .profile_account_shipping_select").css("display","block");
        $("#user_profile_form .profile_account_shipping_text").css("display","none");
        $("#user_profile_form .profile_account_shipping_text #l_city").prop("disabled",true);
        $("#user_profile_form .profile_account_shipping_select #l_city").prop("disabled",false);
    }
    else
    {
        $("#user_profile_form .profile_account_shipping_select").css("display","none");
        $("#user_profile_form .profile_account_shipping_text").css("display","block");
        $("#user_profile_form .profile_account_shipping_text #l_city").prop("disabled",false);
        $("#user_profile_form .profile_account_shipping_select #l_city").prop("disabled",true);
    }

    if ( window.location.pathname.indexOf('/users') == 0 )
    {
        $("#l_country").trigger("change");
        $("#l_zip").trigger("change");
    }


    /*$.ajax({
        url: "/users/getregionandcurrency",
        method: "POST",
        beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
        success: (result)=> {
            $("#l_region").val(result.region);
            $("#l_currency").val(result.currency);
            $("#l_language").val(result.lang);

            $("#l_region").next(".styled-select").text($("#l_region option:selected").text());
            $("#l_currency").next(".styled-select").text($("#l_currency option:selected").text());
            $("#l_language").next(".styled-select").text($("#l_language option:selected").text());
        }
    });*/

    $(".edit-address-button").click(function (event) {
        editUserAddress($(this).data("addressid"));

        var scrollTop = $('.profile__addresses__add').offset().top - 90;
        $('html, body').animate({ scrollTop: scrollTop }, 500);
        $('.profile__addresses__add input').filter(':visible:first').focus();
    })

    $(".edit-foodaddress-button").click(function (event) {
        if ( $(this).data("addressid") )
        {
            $.ajax({
                url: "/users/profile/foodaddresses/edit/",
                data: "addressid="+$(this).data("addressid"),
                method: "POST",
                beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                success: (result)=> {
                    $("#address_type").val("food");
                    $("#address_type").trigger("change");
                    $("#address_type").prop("disabled", true);

                    $(".food_address_form #l_addressname").val(result.address_name);
                    $(".food_address_form #l_lastname").val(result.last_name);
                    $(".food_address_form #l_firstname").val(result.first_name);
                    $(".food_address_form #l_phone").val(result.phone);
                    $(".food_address_form #l_zip").val(result.zipcode);
                    $(".food_address_form #l_city").val(result.city);
                    $(".food_address_form #l_street").val(result.street);
                    $(".food_address_form #l_street_type").val(result.street_type);
                    $(".food_address_form #l_streetno").val(result.streetno);
                    $(".food_address_form #l_street_floor").val(result.street_floor);
                    $(".food_address_form #l_descr_store").val(result.comment1);
                    $(".food_address_form #l_descr").val(result.comment2);
                    $(".food_address_form #addressid").val(result.id);

                    $(".food_address_form #l_country").val(result.country);
                }
            });
        }
    })

    function createSelectAddressEventListener()
    {
        $(".select-address").off("click");
        $(".select-address").on("click", function (event) {

            $('#modal-food-address').addClass('is-open')
            $('#modal-food-address, .modal__layer').fadeIn(250);
            let me = $(event.currentTarget)
            let targetScroll = me.offset().top - 300;

            $("#modal-food-address").css('top', targetScroll)
            $('html, body').animate({ scrollTop: targetScroll - 80 }, 250)
            // $('.header__toggler').addClass('is-active')
            $('.modal__layer').addClass('is-open').fadeIn(250);
            // $('body').addClass('no-scroll')

            var orderid = $(this).data("orderid");

            if ( $(this).data("order-item-id") && $(this).data("order-item-id") != "" )
            {

                $.ajax({
                    url: "/food/openfoodmodify/",
                    data: "orderitemid="+$(this).data("order-item-id"),
                    method: "POST",
                    beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                    success: (result)=> {
                        if ( result )
                        {
                            $("#modal-food-address .form__fields").html(result.html);
                            $("#modal-food-address .carte_name").html(result.title);
                            if ( result.hideSave )
                            {
                                $(".save_food_address").css("display", "none");
                            }
                            else
                            {
                                $(".save_food_address").css("display", "block");
                            }

                            $(".select2_select").select2();



                            // $("#modal-food-address .food-address-select").off("change");
                            addressChanged = false;

                            $("#modal-food-address .food-address-select").on("change", function (event) {

                                addressChanged = true;

                                if ( $(this).data("dayofweek") == 5 )
                                {
                                    $("#modal-food-address .food-address-select[data-dayofweek=6][data-weekgroup="+$(this).data("weekgroup")+"]").val($(this).val()).attr("disabled",false).trigger("change");
                                    $("#modal-food-address .food-address-select[data-dayofweek=0][data-weekgroup="+$(this).data("weekgroup")+"]").val($(this).val()).attr("disabled",false).trigger("change");
                                }

                                if ( $(this).data("dayofweek") == 6 || $(this).data("dayofweek") == 0 )
                                {
                                    $(this).attr("disabled", true);
                                }

                            });


                            $("#modal-food-address .save_food_address").off("click");
                            $("#modal-food-address .save_food_address").on("click", function (event) {

                                if ( !addressChanged )
                                {
                                    $('.modal, .modal-layer, .header__link, .navigation, .dropdown, #modal-video').removeClass('is-open')
                                    $('.modal, .modal__layer').fadeOut(250)
                                    $('.header__toggler').removeClass('is-active')
                                    $('body').removeClass('no-scroll')

                                    return;
                                }

                                var retval = [];

                                $("#modal-food-address .food-address-select").each(function (element) {

                                    var addVal = {
                                        "foodorderitemid": $(this).data("food-order-item-id"),
                                        "orderid": $(this).data("order-id"),
                                        "value": $(this).val()
                                    }

                                    retval.push(addVal);
                                });

                                if ( retval.length > 0 )
                                {
                                    $.ajax({
                                        url: "/food/foodmodify/",
                                        data: {"changes": retval},
                                        method: "POST",
                                        beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                                        success: (result)=> {
                                            if ( result )
                                            {
                                                $('.modal, .modal-layer, .header__link, .navigation, .dropdown, #modal-video').removeClass('is-open')
                                                $('.modal, .modal__layer').fadeOut(250)
                                                $('.header__toggler').removeClass('is-active')
                                                $('body').removeClass('no-scroll')

                                                $(".notification").remove();
                                                $(".content-wrapper").prepend(JSON.parse(result).notification);
                                                setTimeout(() => {
                                                    $(".general-sticky").removeClass("is-visible");
                                                }, stickyTime);

                                                loadOrder(orderid);
                                            }
                                        }
                                    });
                                }

                            });
                        }

                    }
                });

            }

        });
    }

    function loadOrder(orderid)
    {
        $.ajax({
            url: "/users/profile/orders/getorder",
            data: {"orderid": orderid},
            method: "POST",
            beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            success: (result)=> {
                if ( result && result.html )
                {
                    $("#content-"+orderid).html(result.html);
                    createSelectAddressEventListener();
                }
                else
                {
                    $("#content-"+orderid).html("");
                }
            }
        });
    }

    $(".orders__item__toggler").on("click", function (event) {

        loadOrder($(this).data("orderid"));

    })


    $("#address_type").on("change", function (event) {
        if ( $(this).val()=="food" )
        {
            $(".normal_address_form").css("display", "none");
            $(".food_address_form").css("display", "block");
            $(".food_address_form input, .food_address_form select, .food_address_form textarea").prop("disabled", false);
            $(".normal_address_form input, .normal_address_form select, .normal_address_form textarea").prop("disabled", true);
        }
        else if ( $(this).val()=="normal" )
        {
            $(".food_address_form").css("display", "none");
            $(".normal_address_form").css("display", "block");
            $(".normal_address_form input, .normal_address_form select, .normal_address_form textarea").prop("disabled", false);
            $(".food_address_form input, .food_address_form select, .food_address_form textarea").prop("disabled", true);
        }

    })

    $(".food_address_form input, .food_address_form select, .food_address_form textarea").prop("disabled", true);



    if ( window.location.pathname.indexOf("users/profile/addresses/edit") > -1 )
    {

    }


    $(".user_menu_logout").on("click", function (event) {
        sessionStorage.clear();
        window.location.replace("/users/logout");
    });


});
